<template lang="pug">
    .chart-container.targetviews-chart(v-if="enabled" v-loading="loading")
        h3.title {{ $t('Marketing Target Views') }}
        template(v-if="targetPages.length")
            //- .job(v-if="runningJobs.length")
            //-     el-progress(
            //-         :percentage="Math.round(runningJobs[0].percentage * 100) / 100"
            //-         :width="50"
            //-         :show-text="false"
            //-     )
            //-     .summary(v-if="runningJobs[0].percentage && runningJobs[0].current > 0")
            //-         small {{ runningJobs[0].current }} / {{ runningJobs[0].total }}
            //-         small {{ runningJobs[0].percentage.toFixed(2) }}%

            //- transition(name="slide-decent-vertical")
            //-     .status-logs-container.z-depth-1(v-if="logs.length")
            //-         .spinner-container(v-if="loadingLogs")
            //-             .spinner
            //-         StatusLog(v-for="log in logs" :key="log.id" :log="log")
            //-             template(v-if="['success', 'error'].includes(log.status)" slot="actions")
            //-                 a.is-danger(href="#" @click.prevent="hideStatusLog(log)")
            //-                     i.el-icon-fa-times.fas

            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message)" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            horizontal-bar-chart.chart(
                v-else
                v-show="datacollection && datacollection.labels.length"
                ref="chart"
                :chart-data="datacollection"
                :options="chartOptions"
                :height="canvasHeight"
            )
            //- button(@click="generate") Randomize
            .loading-placeholder(
                v-if="!datacollection || !datacollection.labels.length"
                :style="{ 'min-height': `${canvasHeight}px` }"
            )
            .legend
                .row
                    el-switch(
                        v-if="stackable"
                        :active-text="$t('Stacked')"
                        inactive-color="#ff4949"
                        :value="stacked"
                        @change="toggleStacked"
                    )
                    .grow(v-else)
                    ul.no-style-list
                        li.all-visitors
                            el-button(
                                size="mini"
                                @click="toggleDatasets(['all-visitors'], $event)"
                            )
                                span.color(:style="getLegendStyle('all-visitors')")
                                span.label(:class="{ 'strike-through': disabledDatasets.includes('all-visitors') }")
                                    | {{ $t('Unique Visitors') }}
                        li.all-views
                            el-button(
                                size="mini"
                                @click="toggleDatasets(['all-pageviews'], $event)"
                            )
                                span.color(:style="getLegendStyle('all-pageviews')")
                                span.label(:class="{ 'strike-through': disabledDatasets.includes('all-pageviews') }")
                                    | {{ $t('Pageviews') }}
                template(v-if="campaigns.length || marketplaceCampaign")
                    hr
                    ul.no-style-list
                        li.campaign(v-for="campaign in campaigns")
                            el-button(
                                size="mini"
                                @click="toggleDatasets([`${campaign.key}:visitors`, `${campaign.key}:views`], $event)"
                            )
                                span.color(:style="getLegendStyle(`${campaign.key}:visitors`)")
                                span.secondary-color(:style="getLegendStyle(`${campaign.key}:views`)")
                                span.label(:class="{ 'strike-through': disabledDatasets.includes(`${campaign.key}:visitors`) || disabledDatasets.includes(`${campaign.key}:views`)}")
                                    | {{ campaign.name }}
                        li.divider(v-if="campaigns.length && marketplaceCampaign")
                        li.campaign(v-if="marketplaceCampaign")
                            el-button(
                                size="mini"
                                @click="toggleDatasets(['city-offer-marketplace:visitors', 'city-offer-marketplace:views'], $event)"
                            )
                                span.color(:style="getLegendStyle('city-offer-marketplace:visitors')")
                                span.secondary-color(:style="getLegendStyle('city-offer-marketplace:views')")
                                span.label(:class="{ 'strike-through': disabledDatasets.includes('city-offer-marketplace:visitors') || disabledDatasets.includes('city-offer-marketplace:views')}")
                                    | {{ $t('CityOffer Marketplace') }}
        .no-data(v-else-if="!loading")
            //- chalkboard
            //- clipboard
            //- desktop
            //- exclamation-triangle
            //- exclamation-circle
            //- expand
            //- file
            //- folder-open
            //- ghost
            //- inbox
            //- info
            //- poll
            //- poll-h
            //- question
            //- question-cricle (far)
            //- skull-crossbones
            //- sticky-note (far)
            //- user-astronaut
            //- i.el-icon-fa-user-astronaut.fas
            i.el-icon-fa-square-poll-horizontal.fas
            h4 {{ $t('Missing Data') }}
            p {{ $t('Configure the marketing targets and come back another time') }}
    .chart-container.disabled(v-else)
        h3.title {{ $t('Marketing Target Views') }}
        p.body {{ $t('Widget is disabled!') }}
</template>

<i18n>
{
    "de": {
        "CityOffer Marketplace": "CityOffer Marktplatz",
        "Widget is disabled!": "Widget ist deaktiviert!",
        "Marketing Target Views": "Aufrufe nach Marketingzielen",
        "Stacked": "Gestapelt",
        "Pageviews": "Seitenaufrufe",
        "Pageviews Without Campaign": "Seitenaufrufe ohne Kampagne",
        "Unique Visitors": "Besucher",
        "Visitors Without Campaign": "Besucher ohne Kampagne",
        "Total: {total}": "Gesamt: {total}",
        "Daterange": "Zeitraum",
        "The Void": "Die Leere",
        "Missing Data": "Es fehlen Daten",
        "Domain": "Domain",
        "Configure the marketing targets and come back another time": "Konfiguriere die Marketingziele und schau später nochmal vorbei",
        "The summary will be processed asynchronously": "Die Zusammenfassung wird asynchron verarbeitet",
        "You will be notified once the summary is completed": "Sie werden benachrichtigt, sobald die Zusammenfassung abgeschlossen ist"
    },
    "en": {
        "Total: {total}": "Total: {total}"
    }
}
</i18n>

<script>
import Color from 'color'

import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'

import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';

import getUnixTime from 'date-fns/getUnixTime'
import fromUnixTime from 'date-fns/fromUnixTime'

import differenceInDays from 'date-fns/differenceInDays'

import SiteViewsChart from './SiteViewsChart'
import HorizontalBarChart from '@/components/HorizontalBarChart'

import StatisticsApi from '@/store/api/statistics';
import PageApi from '@/store/api/cms/page';

import { adminClient as apolloClient } from '@/store/apollo';
import { appNow, appGetUnixTime } from '@/utils/timezone'

export default {
    name: 'TargetViewsChart',
    extends: SiteViewsChart,
    data() {
        const stacked = true;
        return {
            stacked,
            loading: false,
            error: false,
            right: 'statistics:pageview-summaries',
            windowWidth: undefined,
            datacollection: undefined,
            maxItems: 18,
            targetPages: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 1000,
                },
                plugins: {
                    tooltip: {
                        mode: 'nearest',
                        intersect: false,
                        callbacks: {
                            footer: (tooltipItems) => {
                                if (stacked && tooltipItems.length > 1) {
                                    let total = 0;
                                    tooltipItems.forEach(el => total += el.parsed.x);

                                    return this.$t('Total: {total}', { total })
                                }
                            },
                            beforeTitle: (tooltipItems) => {
                                let addition;

                                const tooltipItem = tooltipItems[0];
                                const dataset = tooltipItem.dataset;
                                switch (dataset.stack) {
                                    case 'visitors':
                                        addition = this.$t('Unique Visitors')
                                        break;

                                    case 'pageviews':
                                        addition = this.$t('Pageviews')
                                        break;
                                }

                                return addition;
                            }
                        }
                    },
                    legend: {
                        position: 'bottom',
                        align: 'end',
                        maxHeight: 10,
                    },
                },
                scales: {
                    y: {
                        stacked,
                    },
                    x: {
                        stacked,
                        beginAtZero: true,
                        offset: false,
                        grid: {
                            offset: false
                        },
                        ticks: {
                            precision: 0
                        }
                    }
                },
                onHover: undefined,
                onClick: undefined
            },

            rawData: [],
        }
    },
    components: {
        HorizontalBarChart
    },
    computed: {
        // jobs() {
        //     return this.allJobs.filter(job => job.type === 'summarize:page-view-statistics')
        // },
        stackable() {
            return !!this.campaigns.length || !!this.marketplaceCampaign
        },
        canvasHeight() {
            let height = this.chartHeight;
            let padding = 30;

            // const numberOfDefaultBars = 2;
            // padding = 20 * (numberOfDefaultBars + this.campaigns.length);

            return height + padding;
        },
        chartHeight() {
            let height = 400
            if (this.summary && this.datacollection) {
                const rows = this.summary.length;

                let h = this.datacollection.datasets.length * (this.barThickness + 2);
                if (this.stacked) {
                    h = 2 * (this.barThickness + 2);
                }

                height = Math.max(height, rows * h);
            }
            return height
        },
        barThickness() {
            let thickness = 16;

            // if (this.summary) {
            //     const rows = this.summary.length;
            //     const rowHeight = (this.chartHeight / rows) - 4;
            //     const numberOfDefaultBars = 2;
            //
            //     let numberOfAllBars = numberOfDefaultBars;
            //     if (this.stacked === false) {
            //         numberOfAllBars += (this.campaigns.length * 2)
            //     }
            //
            //     const height = Math.round(rowHeight / numberOfAllBars);
            //     thickness = Math.min(height, thickness);
            // }

            return thickness;
        },
        summary() {
            let summary = {};

            this.targetPages.forEach(page => {
                summary[page.id] = {
                    id: page.id,
                    label: (_.get(page, 'menuItem.title') || page.title).trim(),
                    views: 0,
                    visitors: 0,
                    noCampaign: {
                        views: 0,
                        visitors: 0,
                    },
                    campaigns: this.summaryCampaigns(),
                }
            });

            if (this.rawData && this.rawData.length) {
                this.targetPages.forEach(page => {
                    const statistics = this.rawData.filter(statistic => statistic.page && statistic.page.id === page.id)
                    statistics.forEach(el => {
                        summary[page.id].views += el.views
                        summary[page.id].visitors += el.visitors

                        if (! el.campaign_key) {
                            summary[page.id].noCampaign.views += el.views
                            summary[page.id].noCampaign.visitors += el.visitors
                        } else {
                            const campaignKey = summary[page.id].campaigns
                                .findIndex(campaign => campaign.key === el.campaign_key);
                            if (campaignKey >= 0) {
                                summary[page.id].campaigns[campaignKey].views += el.views
                                summary[page.id].campaigns[campaignKey].visitors += el.visitors
                            }
                        }
                    })
                })
            }

            let result = _.orderBy(Object.values(summary), 'views', 'desc');

            // if (this.stacked === false) {
            //     let maxItems = this.maxItems;
            //     const base = this.campaigns.length + 2;
            //     const percentage = 100 * base / 2;
            //     maxItems = Math.round(maxItems * 100 / percentage * 1.2);
            //
            //     if (result.length > maxItems && result.filter(el => el.views > 0 && el.visitors > 0).length > 0) {
            //         result = result.filter(el => el.views > 0 && el.visitors > 0);
            //     }
            //
            //     if (result.length > maxItems) result.length = maxItems;
            // }
            return result;
        },
        enabled() {
            // return this.enabledExtensions.includes('marketing');
            return true;
        },
        isNextDisabled() {
            let disabled = startOfDay(addDays(this.daterange[1], 1)) > appNow();
            return disabled;
        },
    },
    methods: {
        summaryCampaigns() {
            const campaigns = _.cloneDeep(this.campaigns).map(element => Object.assign({}, element, { views: 0, visitors: 0 }));
            if (this.marketplaceCampaign) {
                campaigns.unshift({ key: this.marketplaceCampaignKey, name: this.$t('CityOffer Marketplace'), views: 0, visitors: 0 });
            }
            return campaigns;
        },
        async forceUpdate() {
            this.loading = true;

            await apolloClient.clearStore();

            // StatisticsApi.generatePageviewStatistics({ cms: this.activeCms.id })
            //     .finally(this.refetch)
            StatisticsApi.generatePageviewStatistics({ cms: this.activeCms.id })
                .then(() => {
                    this.$notify.success({
                        title: this.$t('The summary will be processed asynchronously'),
                        message: this.$t('You will be notified once the summary is completed'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 3000
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        refetch(loading = true) {
            if (this.targetPages.length) {
                this.loading = loading;

                const filters = {
                    cms: this.activeCms.id,
                    // domain: _.get(this.widget, 'settings.domain') || _.get(this.domainOptions, '0.label'),
                    // period: _.get(this.widget, 'settings.period') || 'day',
                    // from: _.get(this.widget, 'settings.start') || getUnixTime(subDays(new Date, 6)),
                    // to: _.get(this.widget, 'settings.end') || getUnixTime(endOfDay(new Date)),
                    domain: this.domain,
                    period: this.period,
                    from: appGetUnixTime(this.daterange[0]),
                    to: appGetUnixTime(this.daterange[1]),
                    pages: this.targetPages.map(el => parseInt(el.id)),
                }

                StatisticsApi.fetchPageviewStatistics(filters)
                    .then(data => {
                        this.error = false;

                        if (this.stacked && this.stackable !== true) {
                            this.toggleStacked(false);
                        }

                        this.rawData = data;

                        this.$nextTick(() => {
                            this.generate();
                            if (this.$refs.chart) {
                                this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
                                setTimeout(() => this.chartOptions.animation.duration = 0, 1000);
                            }
                        })
                    })
                    .catch(err => {
                        this.datacollection = undefined;

                        const { graphQLErrors } = err

                        let code = 501;
                        let message = 'An error occurred!';

                        if (graphQLErrors) {
                            code = _.get(graphQLErrors, '0.code') || code;
                            message = _.get(graphQLErrors, '0.message') || message;
                        }

                        switch (code) {
                            case 401:
                                this.error = { code, message: 'Unauthorized' };
                                break;
                            case 403:
                                this.error = { code, message: 'Not Allowed' };
                                break;
                            // case 404:
                            //     break;
                            default:
                                this.error = true;
                                break;
                        }

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.loading = false;
            }
        },
        generate() {

            const hasCampaigns = this.campaigns.length || this.marketplaceCampaign;

            let visitorsStack, pageviewsStack;
            let visitorsLabel = this.$t('Unique Visitors');
            let pageviewsLabel = this.$t('Pageviews');
            if (hasCampaigns) {
                if (this.enabledExtensions.includes('marketing') && this.stacked) {
                    visitorsLabel = this.$t('Visitors Without Campaign');
                    pageviewsLabel = this.$t('Pageviews Without Campaign');

                    visitorsStack = 'visitors';
                    pageviewsStack = 'pageviews';
                } else {
                    // allVisitorsLabel = this.$t('Unique Visitors'),
                }
            }

            this.datacollection = {
                labels: [],
                datasets: [
                    {
                        key: 'all-visitors',
                        hidden: this.disabledDatasets.indexOf('all-visitors') >= 0,
                        label: visitorsLabel,
                        borderColor: 'rgb(0, 0, 0)',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        borderWidth: 1,
                        fill: true,

                        barPercentage: 0.6,
                        categoryPercentage: 0.9,

                        // borderDash: [10,10],
                        barThickness: this.barThickness,
                        maxBarThickness: this.barThickness * 0.8,
                        stack: visitorsStack,
                        data: [],
                    },
                    {
                        key: 'all-pageviews',
                        hidden: this.disabledDatasets.indexOf('all-pageviews') >= 0,
                        label: pageviewsLabel,
                        borderColor: 'rgb(160, 160, 160)',
                        backgroundColor: 'rgba(160, 160, 160, 0.7)',
                        borderWidth: 1,
                        fill: true,

                        barPercentage: 0.6,
                        categoryPercentage: 0.9,

                        // borderDash: [10,10],
                        barThickness: this.barThickness,
                        maxBarThickness: this.barThickness * 0.8,
                        stack: pageviewsStack,
                        data: [],
                    },
                ],
            }

            if (this.marketplaceCampaign) {
                this.datacollection.datasets.push({
                    key: 'city-offer-marketplace:visitors',
                    hidden: this.disabledDatasets.indexOf('city-offer-marketplace:visitors') >= 0,
                    label: this.$t('Unique Visitors') + ' (' + this.$t('CityOffer Marketplace') + ')',
                    borderColor: '#be1521',
                    backgroundColor: Color('#be1521').fade(0.3).rgb().string(),
                    borderWidth: 1,
                    fill: false,
                    barPercentage: 0.6,
                    categoryPercentage: 0.9,
                    barThickness: this.barThickness,
                    maxBarThickness: this.barThickness * 0.8,
                    stack: visitorsStack,
                    data: [],
                });
                this.datacollection.datasets.push({
                    key: 'city-offer-marketplace:views',
                    hidden: this.disabledDatasets.indexOf('city-offer-marketplace:views') >= 0,
                    label: this.$t('Pageviews') + ' (' + this.$t('CityOffer Marketplace') + ')',
                    borderColor: '#95c01f',
                    backgroundColor: Color('#95c01f').fade(0.3).rgb().string(),
                    borderWidth: 1,
                    fill: false,
                    barPercentage: 0.6,
                    categoryPercentage: 0.9,
                    barThickness: this.barThickness,
                    maxBarThickness: this.barThickness * 0.8,
                    stack: pageviewsStack,
                    data: [],
                });
            }

            if (this.rawData && this.rawData.length) {
                this.rawData.forEach(el => {
                    if (! el.campaign_key) return;
                    const hex = _.get(el.campaign, 'color') || '#6b52ef';

                    let visitorsLabel = this.$t('Unique Visitors') + ` (${el.campaign_name})`;
                    let pageviewsLabel = this.$t('Pageviews') + ` (${el.campaign_name})`;
                    if (hasCampaigns) {
                        if (this.enabledExtensions.includes('marketing') && this.stacked) {
                            visitorsLabel = el.campaign_name;
                            pageviewsLabel = el.campaign_name;
                        } else {
                            // allVisitorsLabel = this.$t('Unique Visitors'),
                        }
                    }

                    if (! this.datacollection.datasets.find(dataset => dataset.key === `${el.campaign_key}:visitors`)) {
                        this.datacollection.datasets.push({
                            key: `${el.campaign_key}:visitors`,
                            hidden: this.disabledDatasets.indexOf(`${el.campaign_key}:visitors`) >= 0,
                            label: visitorsLabel,
                            borderColor: hex,
                            backgroundColor: Color(hex).fade(0.3).rgb().string(),
                            fill: false,

                            barPercentage: 0.6,
                            categoryPercentage: 0.9,

                            // borderDash: [10,10],
                            barThickness: this.barThickness,
                            maxBarThickness: this.barThickness * 0.8,
                            stack: visitorsStack,
                            data: [],
                        });
                    }
                    if (! this.datacollection.datasets.find(dataset => dataset.key === `${el.campaign_key}:views`)) {
                        this.datacollection.datasets.push({
                            key: `${el.campaign_key}:views`,
                            hidden: this.disabledDatasets.indexOf(`${el.campaign_key}:views`) >= 0,
                            label: pageviewsLabel,
                            borderColor: Color(hex).fade(0.5).rgb().string(),
                            backgroundColor: Color(hex).fade(0.5).fade(0.3).rgb().string(),
                            fill: false,

                            barPercentage: 0.6,
                            categoryPercentage: 0.9,

                            // borderDash: [10,10],
                            barThickness: this.barThickness,
                            maxBarThickness: this.barThickness * 0.8,
                            stack: pageviewsStack,
                            data: [],
                        });
                    }
                });
            }

            this.summary.forEach(el => {
                this.datacollection.labels.push(el.label);

                if (hasCampaigns && this.enabledExtensions.includes('marketing') && this.stacked) {
                    this.datacollection.datasets[0].data.push(el.noCampaign.visitors)
                    this.datacollection.datasets[1].data.push(el.noCampaign.views)
                } else {
                    this.datacollection.datasets[0].data.push(el.visitors)
                    this.datacollection.datasets[1].data.push(el.views)
                }

                el.campaigns.forEach(campaign => {
                    const viewsDatasetIndex = this.datacollection.datasets.findIndex(dataset => {
                        return dataset.key === `${campaign.key}:views`;
                    });
                    if (viewsDatasetIndex >= 0) {
                        this.datacollection.datasets[viewsDatasetIndex].data.push(campaign.views)
                    }

                    const visitorsDatasetIndex = this.datacollection.datasets.findIndex(dataset => {
                        return dataset.key === `${campaign.key}:visitors`;
                    });
                    if (visitorsDatasetIndex >= 0) {
                        this.datacollection.datasets[visitorsDatasetIndex].data.push(campaign.visitors)
                    }
                })
            })

            // cleanup datasets

            // const filterDatasets = maxItems => {
            //     if (maxItems === Infinity) {
            //         for (let i = 0; i < this.datacollection.labels.length; i++) {
            //             let empty = true;
            //             this.datacollection.datasets.forEach(dataset => {
            //                 if (dataset.data[i] > 0) empty = false;
            //             })

            //             if (empty) {
            //                 this.datacollection.labels.length = i;
            //                 this.datacollection.datasets.forEach(dataset => {
            //                     dataset.data.length = i;
            //                 })
            //                 break;
            //             }
            //         }
            //     } else {
            //         this.datacollection.labels.length = maxItems;
            //         this.datacollection.datasets.forEach(dataset => {
            //             dataset.data.length = maxItems;
            //         })
            //     }
            // }

            // let maxItems = 15;
            // const base = this.campaigns.length + 2;
            // const percentage = 100 * base / 2;
            // maxItems = Math.round(maxItems * 100 / percentage * 1.2);
            // // if (result.length > maxItems) result = result.filter(el => el.views > 0 && el.visitors > 0);
            // // if (result.length > maxItems) result.length = maxItems;

            // if (this.datacollection.labels.length > maxItems) filterDatasets(Infinity)
            // if (this.datacollection.labels.length > maxItems) filterDatasets(maxItems);
        },
        disabledDate(date) {
            return date > appNow();
        },
        next() {
            let daterange = this.daterange

            let difference = differenceInDays(daterange[1], daterange[0]) + 1;
            if (addDays(daterange[1], difference) > appNow()) {
                daterange[1] = endOfDay(appNow());
                daterange[0] = startOfDay(subDays(daterange[1], difference - 1));
            } else {
                daterange[0] = addDays(daterange[0], difference);
                daterange[1] = addDays(daterange[1], difference);
            }

            this.daterange = daterange
        },
        prev() {
            let daterange = this.daterange

            let difference = differenceInDays(daterange[1], daterange[0]) + 1;
            daterange[0] = subDays(daterange[0], difference);
            daterange[1] = subDays(daterange[1], difference);

            this.daterange = daterange
        },
        fetchDependencies() {
            let dependencies = []

            if (this.enabledExtensions.includes('marketing')) {
                const fetchTargetPages = PageApi.fetchPages({
                    is_marketing_target: true,
                    cms: this.activeCms.id,
                }).then(data => this.targetPages = data)
                dependencies.push(fetchTargetPages)
            } else {
                this.targetPages = []
            }

            if (dependencies.length) {
                Promise.all(dependencies)
                    .then(this.refetch)
                    .catch(err => {
                        const { graphQLErrors } = err

                        let code = 501;
                        let message = 'An error occurred!';

                        if (graphQLErrors) {
                            code = _.get(graphQLErrors, '0.code') || code;
                            message = _.get(graphQLErrors, '0.message') || message;
                        }

                        switch (code) {
                            case 401:
                                this.error = { code, message: 'Unauthorized' };
                                break;
                            case 403:
                                this.error = { code, message: 'Not Allowed' };
                                break;
                            // case 404:
                            //     break;
                            default:
                                this.error = true;
                                break;
                        }

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);
                    })
                    .finally(() => {
                        // this.loading = false
                    })
            } else {
                this.refetch();
            }
        },
        initialize() {
            this.loading = true

            this.datacollection = undefined;
            this.targetPages = []

            this.fetchDependencies();
        },
        toggleStacked(stacked) {
            this.stacked = stacked

            this.$set(this.chartOptions.scales.y, 'stacked', stacked)
            this.$set(this.chartOptions.scales.x, 'stacked', stacked)

            this.$nextTick(() => {
                this.generate();
                if (this.$refs.chart) {
                    this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
                }
            })
        }
    },
    mounted () {
        // this.updateWindowWidth();

        this.chartOptions.animation.duration = 1000
        this.initialize();

        // window.addEventListener('resize', this.updateWindowWidth);
    },
}
</script>
